import React from "react";
import { styled } from '../../stitches.config';

import bridSubmitProjectImage from '../assets/images/brid-ostatni-kafel-photo.png';

const BridSubmitProjectHome: React.FC = () => {

    return (
        <Section>
            <div className="container">
                <FlexWrapper className="row">
                    <ImageWrapper>
                        <img src={bridSubmitProjectImage}
                            alt="Nie znalazłeś interesującego Cię tematu?"
                            width={340}
                            height={452}
                        />
                    </ImageWrapper>
                    <div className="col-xs-9 col-lg-offset-5 col-lg-7">
                        <h1>
                            Nie znalazłeś interesującego Cię tematu?
                        </h1>
                        <p>
                            Swoje pomysły w każdej chwili możesz zgłaszać
                            <br />
                            pod adresem <a href="mailto:brid@natemat.pl">brid@natemat.pl</a>.
                        </p>
                    </div>
                </FlexWrapper>
            </div>
        </Section>
    );
};

const Section = styled('section', {
    background: '#131212',
    marginTop: 'calc(452px - 396px)',
    '& > .container': {
        minHeight: '396px'
    },
    'a': {
        color: '#FF6400'
    },
    'p': {
        fontSize: '16px',
        lineHeight: '24px'
    },
    'h1': {
        fontSize: '24px',
        lineHeight: '30px'
    },
    '.container': {
        position: 'relative',
        display: 'flex'
    },
    '@bp3': {
        'p': {
            fontSize: '16px',
            lineHeight: '24px'
        },
        'h1': {
            fontSize: '38px',
            lineHeight: '42px'
        }
    }
});

const FlexWrapper = styled('div', {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    width: '100%',
});

const ImageWrapper = styled('div', {
    position: 'absolute',
    bottom: '0',
    right: '-45%',
    '@bp3': {
        right: '0'
    },
    '@bp5': {
        right: 'unset'
    }
});

export default BridSubmitProjectHome;
